export const container = ({ theme: { colors } }) => ({
    color: colors.cyan,
});

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
    }),
};
